module.exports = __webpack_public_path__ + "media/images/link-icon-26cfa53a0f1c3724033fbd14d25311e3.svg";